import {
    getData,
} from './Services'

export const getProvincias = async () => {
    const res = await getData('/provincias/provincias_select');
    const provinciasTransformadas = res
        .filter(p => p.pcia_descripcion) // filtra los nulos
        .map(p => {
            const descripcion = p.pcia_descripcion.toLowerCase()
                .replace(/\b\w/g, l => l.toUpperCase()); // Capitaliza cada palabra
            return {
                id: p.id,
                value: {
                    id: p.id,
                    descripcion,
                },
                label: descripcion
            };
        });
    return provinciasTransformadas
}
